import type {
  ProductSupplierDto,
  StockImportConfigShortModel,
} from '../types/stockImports.types'

export const SELF_SUPPLIER_SNAPSHOT_KEY = '__SELF_PRODUCT_SUPPLIER__'
export const ALL_SUPPLIERS_SNAPSHOT_KEY = '__ALL_PRODUCT_SUPPLIERS__'
export const ALL_SUPPLIERS_LABEL = 'Все поставщики'

export const isAllSuppliersSelected = (supplierId?: string) =>
  supplierId === ALL_SUPPLIERS_SNAPSHOT_KEY

export const resolveRequestSupplierId = (
  supplierId: string | undefined,
  isProductSupplierUser: boolean
): string | null => {
  if (isProductSupplierUser || !supplierId) return null
  if (
    supplierId === SELF_SUPPLIER_SNAPSHOT_KEY ||
    supplierId === ALL_SUPPLIERS_SNAPSHOT_KEY
  )
    return null
  return supplierId
}

export const buildSupplierOptions = (suppliers: ProductSupplierDto[]) => [
  { value: ALL_SUPPLIERS_SNAPSHOT_KEY, label: ALL_SUPPLIERS_LABEL },
  ...suppliers.map((supplier) => ({
    value: supplier.id,
    label: supplier.description,
  })),
]

export const formatJournalConfigLabel = (
  config: StockImportConfigShortModel,
  sourceLabel: string,
  withSupplier: boolean
) => {
  const storeLabel = config.store?.description ?? 'Без склада'
  const base = `${storeLabel} / ${sourceLabel}`
  if (!withSupplier) return base
  return `${config.productSupplier?.description ?? 'Без поставщика'} / ${base}`
}

export const buildJournalConfigOption = (
  config: StockImportConfigShortModel,
  sourceLabel: string,
  withSupplier: boolean
) => ({
  value: config.id,
  label: formatJournalConfigLabel(config, sourceLabel, withSupplier),
  supplier: config.productSupplier?.description ?? 'Без поставщика',
  store: config.store?.description ?? 'Без склада',
  sourceType: sourceLabel,
})

export type JournalConfigOption = ReturnType<typeof buildJournalConfigOption>

export const matchesJournalConfigOption = (
  search: string,
  option: Pick<JournalConfigOption, 'supplier' | 'store' | 'sourceType'>
) => {
  const query = search.trim().toLowerCase()
  return [option.supplier, option.store, option.sourceType].some((value) =>
    value.toLowerCase().includes(query)
  )
}

const JOURNAL_CONFIG_HEADERS = {
  supplier: 'Поставщик',
  store: 'Склад',
  sourceType: 'Тип загрузки',
} as const

export const getJournalConfigColumnWidths = (
  options: JournalConfigOption[]
) => {
  const widthOf = (column: keyof typeof JOURNAL_CONFIG_HEADERS) =>
    Math.max(
      JOURNAL_CONFIG_HEADERS[column].length,
      ...options.map((option) => option[column].length)
    )
  return {
    supplier: widthOf('supplier'),
    store: widthOf('store'),
    sourceType: widthOf('sourceType'),
  }
}
